const { VITE_API_PREFIX } = import.meta.env;

const apiPrefix = `${VITE_API_PREFIX}/api`;

export const VITE_JIT_LOGIN_URL = `${apiPrefix}/v4/auth/jit-login`;
export const VITE_REQUEST_OTP_URL = `${apiPrefix}/v1/messages`;
export const VITE_VERIFY_OTP_URL = `${apiPrefix}/v1/otp-verifications`;
export const VITE_VERIFY_DOB_URL = `${apiPrefix}/v1/call/{callId}/dob-verification`;
export const VITE_PARTNER_URL = `${apiPrefix}/v1/bootstrap`;
export const VITE_CREATE_CALL_URL = `${apiPrefix}/v3/calls`;
export const LOAD_BOOTSTRAP_DATA = `${apiPrefix}/v1/bootstrap`;
export const LOAD_REPLIES_DATA = `${apiPrefix}/v1/calls/{callId}/responses`;
export const INITIAL_ACCESS_TOKEN = `${apiPrefix}/v1/oauth/token`;
export const HANDLE_OPT_IN = `${apiPrefix}/v1/profiles`;
export const READ_RESPONSE = `${apiPrefix}/v1/responses/{id}`;
export const GET_STATUS_INFO = `${apiPrefix}/v1/call/{request_id}/summary`;
export const GET_IVR_MAP = `${apiPrefix}/v1/partners/{partnerId}/wma-map`;
export const GET_PROVIDER_LIST_URL = `${apiPrefix}/v1/partners/{partnerId}/providers`;
export const SUBMIT_PATIENT_FORM = `${apiPrefix}/v1/calls`;
export const COOKIE_CALLBACK_NUMBER = 'wma_cookie_callback_number';
export const MAX_OTP_ATTEMPTS = 3;
export const ERROR_ROUTE = '/error/';
export const ERROR_TYPES = Object.freeze({
    EXPIRED_LINK: 'expired_link',
    INCORRECT_URL: 'incorrect_url',
    INVALID_URL: 'invalid_url',
    OFFICE_BUSY: 'office_busy',
    SERVER_ERROR: 'server_error',
});
export const ERROR_PATHS = Object.freeze({
    EXPIRED_LINK: `${ERROR_ROUTE}${ERROR_TYPES.EXPIRED_LINK}`,
    INCORRECT_URL: `${ERROR_ROUTE}${ERROR_TYPES.INCORRECT_URL}`,
    INVALID_URL: `${ERROR_ROUTE}${ERROR_TYPES.INVALID_URL}`,
    OFFICE_BUSY: `${ERROR_ROUTE}${ERROR_TYPES.OFFICE_BUSY}`,
    SERVER_ERROR: `${ERROR_ROUTE}${ERROR_TYPES.SERVER_ERROR}`,
});
export const HTTP_STATUS = Object.freeze({
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
});
